import { ApiService } from "@core/api/api-service";
import { errorHandlingInterceptor } from "@core/api/interceptors/error-handling-interceptor";
import { addResponseInterceptor } from "@core/api/interceptors/interceptor";
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";

export class ExternalApiService implements ApiService {
	axiosInstance: AxiosInstance;

	constructor(private readonly axiosInstanceProvider: () => AxiosInstance) {
		this.axiosInstance = this.initiateAxiosInstance();
	}

	private initiateAxiosInstance(): AxiosInstance {
		const axiosInstance = axios.create();
		addResponseInterceptor(axiosInstance, errorHandlingInterceptor());

		return axiosInstance;
	}

	get<T = unknown, R = AxiosResponse<T>>(url: string, config?: AxiosRequestConfig): Promise<R> {
		return this.axiosInstance.get(url, config);
	}

	post<T = unknown, R = AxiosResponse<T>>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<R> {
		return this.axiosInstance.post(url, data, config);
	}

	put<T = unknown, R = AxiosResponse<T>>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<R> {
		return this.axiosInstance.put(url, data, config);
	}

	delete<T = unknown, R = AxiosResponse<T>>(url: string, config?: AxiosRequestConfig): Promise<R> {
		return this.axiosInstance.delete(url, config);
	}
}
